<template>
	<div
		class="tile"
		draggable="true"
		@dragstart="$emit('drag-start', $event)"
		@dragover="$emit('drag-over', $event)"
		@drop="$emit('drag-finish', $event)"
		@dragend="$emit('drag-end', $event)"
	>
		<!-- caption -->
		<div class="tile-container">
			<div class="tile-header">Bar Chart</div>
			<div class="buttons">
				<div class="button" title="Close Tile" @click="$emit('remove-tile')">
					<svg width="24" height="24" viewBox="0 0 24 24">
						<path
							d="M12.71,12l4.64-4.65a.49.49,0,1,0-.7-.7L12,11.29,7.35,6.65a.49.49,0,0,0-.7.7L11.29,12,6.65,16.65a.48.48,0,0,0,0,.7.48.48,0,0,0,.7,0L12,12.71l4.65,4.64a.48.48,0,0,0,.7,0,.48.48,0,0,0,0-.7Z"
						/>
					</svg>
				</div>
			</div>
		</div>
		<!-- content -->
		<div class="tile-content">
			<wj-flex-chart :chartType="'Bar'" :itemsSource="data" :bindingX="'date'" :palette="palette">
				<wj-flex-chart-axis :wjProperty="'axisX'" :format="'MMM yy'"></wj-flex-chart-axis>
				<wj-flex-chart-series :name="'Sales'" :binding="'sales'"></wj-flex-chart-series>
				<wj-flex-chart-series :name="'Expenses'" :binding="'expenses'"></wj-flex-chart-series>
				<wj-flex-chart-series :name="'Profit'" :binding="'profit'" :chartType="'LineSymbols'"></wj-flex-chart-series>
			</wj-flex-chart>
		</div>
	</div>
</template>

<script>
import '@mescius/wijmo.vue2.chart';
import DataService from '../services/data.service';

export default {
	name: 'BarChart',
	props: ['palette'],
	data: () => ({ data: DataService.getData() }),
};
</script>